<div
  *ngIf="canAccess"
  class="p-2 bg-gray-opacity rounded-2xl flex justify-around md:justify-center md:gap-4 md:p-4"
>
  <div class="flex flex-col items-center text-center">
    <span class="text-lg font-semibold mb-2">Dashboard backoffice</span>
    <img
      class="relative rotate-minus12"
      width="73px"
      src="./assets/icons/card.svg"
    />
  </div>

  <div class="flex flex-col">
    <a (click)="goToUsers()" class="cursor-pointer text-light-red hover:text-zendy-dark-red hover:underline py-1">Gestionar usuarios</a>
    <a (click)="goToPartners()" class="cursor-pointer text-light-red hover:text-zendy-dark-red hover:underline py-1">Gestionar partners BTB</a>
    <a (click)="goToPromoCodes()" class="cursor-pointer text-light-red hover:text-zendy-dark-red hover:underline py-1">Gestionar códigos de promoción</a>
    <a (click)="goToConverter()" class="cursor-pointer text-light-red hover:text-zendy-dark-red hover:underline py-1">Conversión de excels Holded -> Sage200</a>
  </div>
</div>

<div class="flex justify-center items-center gap-4 py-4 bg-white rounded-lg shadow-md mx-4 flex-wrap">
  <!-- busqueda por filtros -->

    <div class="flex flex-col items-start">
      <label for="fechaInicio" class="text-sm font-medium text-gray-700">Fecha inicio</label>
      <input
        id="fechaInicio"
        type="date"
        [(ngModel)]="fechaInicio"
        class="mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-sm"
      />
    </div>
    <div class="flex flex-col items-start">
      <label for="fechaFin" class="text-sm font-medium text-gray-700">Fecha fin</label>
      <input
        id="fechaFin"
        type="date"
        [(ngModel)]="fechaFin"
        class="mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-sm"
      />
    </div>

    <div class="flex flex-col items-start">
      <label for="filtro" class="text-sm font-medium text-gray-700">Filtro</label>
      <select
        id="filtro"
        [(ngModel)]="Filtro"
        class="mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-sm"
      >
        <option *ngFor="let f of filtrosDisponibles" [value]="f">{{ f }}</option>
      </select>
    </div>

    <div class="flex flex-col items-start">
      <label for="telefono" class="text-sm font-medium text-gray-700">Teléfono (opcional)</label>
      <input
        id="telefono"
        type="text"
        [(ngModel)]="telefono"
        placeholder="+4479..."
        class="mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-sm"
      />
    </div>

    <div class="flex items-end h-full pt-5">
      <button
        (click)="buscarPorFechas()"
        class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg shadow transition-colors"
      >
        Buscar
      </button>
    </div>


  <!-- contenido llamadas-->
  <div>
    <div style="width: 100%; overflow-x: auto; margin-top: 1rem;padding: 15px;">
      <h3>Detalle de llamadas por  {{ Filtro }}</h3>
      <table *ngIf="chartData.length > 0" cellpadding="5" cellspacing="0" 
            style="border-collapse: collapse; width: max-content; min-width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 5px; position: sticky; left: 0; background: #f3f3f3; z-index: 2;">
              {{ Filtro }}
            </th>
            <th *ngFor="let row of chartData" style="border: 1px solid #000; padding: 5px; background: #f3f3f3;">
              {{ row.hour }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border: 1px solid #000; padding: 5px; position: sticky; left: 0; background: #fff; z-index: 1;">
              Cantidad
            </td>
            <td *ngFor="let row of chartData" style="border: 1px solid #000; padding: 5px; text-align: center;">
              {{ row.count }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 5px; position: sticky; left: 0; background: #fff; z-index: 1;">
              Carga Total
            </td>
            <td *ngFor="let row of chartData" style="border: 1px solid #000; padding: 5px;">
              € {{ row.total_charge | number:'1.2-2' }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 5px; position: sticky; left: 0; background: #fff; z-index: 1;">
              Tiempo Total
            </td>
            <td *ngFor="let row of chartData" style="border: 1px solid #000; padding: 5px;">
              {{ row.total_time | number:'1.2-2'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p *ngIf="chartData.length === 0">No hay datos disponibles.</p>

    <div  class="flex items-end" #Detallecostollamadas style="width: 85%; height: 400px;padding: 20px;"></div>
  </div>

  <!-- Contenido transacciones -->
   <div>
    <div class="flex gap-4" overflow-auto>
        <!-- Tabla -->
        <div class="flex-1 overflow-auto" style="max-width: 800px;">
          <table *ngIf="transactionList.length > 0" style="border-collapse: collapse; width: max-content; min-width: 90%;">
            <thead>
              <tr>
                <th style="position: sticky; left: 0; background: white; border: 1px solid #000; padding: 5px;">Nombre</th>
                <th style="border: 1px solid #000; padding: 5px;">Phonenumber</th>
                <th style="border: 1px solid #000; padding: 5px;">Email</th>
                <th style="border: 1px solid #000; padding: 5px;">Fecha Alta</th>
                <th style="border: 1px solid #000; padding: 5px;">CallOut</th>
                <th style="border: 1px solid #000; padding: 5px;">Call</th>
                <th style="border: 1px solid #000; padding: 5px;">Esim</th>
                <th style="border: 1px solid #000; padding: 5px;">Transferencia</th>
                <th style="border: 1px solid #000; padding: 5px;">Activo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tx of transactionList">
                <td style="position: sticky; left: 0; background: white; border: 1px solid #000; padding: 5px;">{{ tx.full_name }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ tx.phonenumber }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ tx.email }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ tx.usercreatedate }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ tx.Callout | number:'1.2-2' }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ tx.Call | number:'1.2-2' }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ tx.esim | number:'1.2-2' }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ tx.Transferencia | number:'1.2-2' }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ tx.Activo }}</td>
              </tr>
            </tbody>
          </table>
          <p *ngIf="transactionList.length === 0">No hay transacciones disponibles.</p>
        </div>
        <br>
      </div>
      <!-- Gráfico -->
      <div class="flex-1" #transactionChart style="min-width: 500px; height: 400px; padding: 20px;max-height: 500px;"></div>
   </div>
  
  <!-- 🔹 Tabla y gráfico de resumen mensual -->
<div style="margin-top: 2rem;">
  <h3>Resumen mensual de transacciones</h3>

  <!-- Tabla -->
  <table *ngIf="transactionSumary.length > 0" style="border-collapse: collapse; width: 100%; margin-bottom: 20px;">
    <thead>
      <tr>
        <th style="border: 1px solid #000; padding: 5px;">Mes</th>
        <th style="border: 1px solid #000; padding: 5px;">eSIM (€)</th>
        <th style="border: 1px solid #000; padding: 5px;">Call (€)</th>
        <th style="border: 1px solid #000; padding: 5px;">Transferencia (€)</th>
        <th style="border: 1px solid #000; padding: 5px;">Total (€)</th>
        <th style="border: 1px solid #000; padding: 5px;">Tx eSIM (#)</th>
        <th style="border: 1px solid #000; padding: 5px;">Tx Call (#)</th>
        <th style="border: 1px solid #000; padding: 5px;">Tx Transferencia (#)</th>
        <th style="border: 1px solid #000; padding: 5px;">Usuarios Activos (#)</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of transactionSumary">
        <td style="border: 1px solid #000; padding: 5px;">{{ item.month }}</td>
        <td style="border: 1px solid #000; padding: 5px;">€ {{ item.esim_amount | number:'1.2-2' }}</td>
        <td style="border: 1px solid #000; padding: 5px;">€ {{ item.call_amount | number:'1.2-2' }}</td>
        <td style="border: 1px solid #000; padding: 5px;">€ {{ item.transferencia_amount | number:'1.2-2' }}</td>
        <td style="border: 1px solid #000; padding: 5px;">€ {{ item.Total_amount | number:'1.2-2' }}</td>
        <td style="border: 1px solid #000; padding: 5px;">{{ item.esim_count }}</td>
        <td style="border: 1px solid #000; padding: 5px;">{{ item.call_count }}</td>
        <td style="border: 1px solid #000; padding: 5px;">{{ item.transferencia_count }}</td>
        <td style="border: 1px solid #000; padding: 5px;">{{ item.Activos }}</td>
      </tr>
    </tbody>
  </table>

  <div #transactionSumaryChart style="width: 100%; height: 450px;"></div>
</div>
  

  

  
</div>




<style>
  .grid {
    display: grid;
  }

  .grid-cols-2 {
    grid-template-columns: repeat(2, 1fr);
  }

  .gap-4 {
    gap: 16px;
  }

  .flex {
    display: flex;
  }

  .flex-col {
    flex-direction: column;
  }

  .w-full {
    width: 100%;
  }

  :host {
  display: block;
  width: 100%;
}
</style>
